import '@content/foundations/src/index'
import asWebComponent from '../../asWebComponent'
import MediaTextWithChips from './MediaTextWithChips'

export default asWebComponent(MediaTextWithChips, 'nb-media-text-with-chips', [
    'data'
])
